var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._t("default",[_vm._v("label")])],2),_c('input',_vm._b({on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.props,false))])}
var staticRenderFns = []

export { render, staticRenderFns }